"use client";

import { useState, useCallback } from "react";
import { FormattedPost } from "@/types";

interface UseSharePostReturn {
  isSharePanelOpen: boolean;
  sharePost: FormattedPost | null;
  openSharePanel: (post: FormattedPost) => void;
  closeSharePanel: () => void;
}

export function useSharePost(): UseSharePostReturn {
  const [isSharePanelOpen, setIsSharePanelOpen] = useState(false);
  const [sharePost, setSharePost] = useState<FormattedPost | null>(null);

  const openSharePanel = useCallback((post: FormattedPost) => {
    setSharePost(post);
    setIsSharePanelOpen(true);
  }, []);

  const closeSharePanel = useCallback(() => {
    setIsSharePanelOpen(false);
    setSharePost(null);
  }, []);

  return {
    isSharePanelOpen,
    sharePost,
    openSharePanel,
    closeSharePanel,
  };
}
